module.exports = __webpack_public_path__ + "img/Dealer.1829193b.png";